import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { translateStoreCategory } from "../../../utils/storeUtils";
import "./CategoryBreadcrumbs.css";

function safeSlug(s) {
  return String(s || "").trim().toLowerCase();
}

export default function CategoryBreadcrumbs({ crumbs = [] }) {
  const { t, i18n } = useTranslation("global");
  const isRtl = String(i18n.language || "").toLowerCase().startsWith("ar");
  const list = Array.isArray(crumbs) ? crumbs : [];
  if (list.length === 0) return null;

  const lastIdx = list.length - 1;

  return (
    <nav
      className="cb"
      aria-label={t("store.breadcrumbAria", { defaultValue: "Breadcrumb" })}
      dir={isRtl ? "rtl" : "ltr"}
      lang={isRtl ? "ar" : "en"}
    >
      <Link className="cb-link" to="/store">
        {t("header.home", { defaultValue: "Home" })}
      </Link>
      {list.map((c, idx) => {
        const key = c._id || c.slug || c.label || idx;
        const isLast = idx === lastIdx;
        const label = translateStoreCategory(t, c);
        return (
          <React.Fragment key={key}>
            <span className="cb-sep" aria-hidden="true">
              ›
            </span>
            {isLast ? (
              <span className="cb-current" aria-current="page">
                {label}
              </span>
            ) : (
              <Link className="cb-link" to={`/store/category/${safeSlug(c.slug)}`}>
                {label}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}

